import { axiosInstance } from '.'
import {
  SECONDARY_MARKET_MATCH_V1,
  SECONDARY_MARKET_ORDERS_V1,
  SECONDARY_MARKET_ORDER_STATUS_V1,
  SECONDARY_MARKET_SETTINGS_V1,
} from './endpoints'

export type SecondaryMarketOrder = {
  id: number
  order_id: string
  type: 'SELL' | 'BUY_INTEREST'
  investor_id: number
  opportunity_id: number
  quantity: number
  price_basis: string
  limit_price: number | null
  reference_price: number | null
  status: string
  counterparty_order_id: number | null
  agreed_unit_price: number | null
  settlement_status: string | null
  window_label: string | null
  metadata?: Record<string, unknown> | null
  opportunity_title?: string
  investor_name?: string
  investor_email?: string
  counterparty_order_ref?: string
  created_at: string
}

export type SecondaryMarketSettings = {
  is_open: boolean
  window_label: string | null
  closes_at: string | null
}

export const secondaryMarketServices = {
  getOrders: async (params?: Record<string, string | number>) => {
    const { data, status } = await axiosInstance.get(SECONDARY_MARKET_ORDERS_V1, {
      params,
    })
    return { orders: data.orders as SecondaryMarketOrder[], total: data.total as number, status }
  },

  getSettings: async () => {
    const { data, status } = await axiosInstance.get(SECONDARY_MARKET_SETTINGS_V1)
    return { settings: data as SecondaryMarketSettings, status }
  },

  updateSettings: async (payload: Partial<SecondaryMarketSettings>) => {
    const { data, status } = await axiosInstance.patch(SECONDARY_MARKET_SETTINGS_V1, payload)
    return { settings: data as SecondaryMarketSettings, status }
  },

  matchOrders: async (payload: {
    sell_order_id: number
    buy_order_id: number
    agreed_unit_price: number
  }) => {
    const { data, status } = await axiosInstance.post(SECONDARY_MARKET_MATCH_V1, payload)
    return { data, status }
  },

  updateOrderStatus: async (orderId: number, status: string) => {
    const { data, status: httpStatus } = await axiosInstance.patch(
      SECONDARY_MARKET_ORDER_STATUS_V1(orderId),
      { status },
    )
    return { data, status: httpStatus }
  },
}
